import { useState } from 'react';

import { StatusAlertIcon } from '@infinex/ui-icons';
import { cn } from '@infinex/ui-styles';

import { LoadingSpinner } from '../../components/LoadingSpinner';

interface NftImageProps {
  identifier: string;
  imageUrl?: string;
  className?: string;
  alt?: string;
}

export const NftImage = ({
  identifier,
  imageUrl,
  className,
  alt,
}: NftImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div className={cn('bg-fill flex items-center', className)}>
      {imageUrl && imageUrl !== '' ? (
        <>
          {!isLoaded && <LoadingSpinner className="m-auto" />}
          <img
            src={imageUrl}
            alt={alt ?? `nft-image-${identifier}`}
            style={{ display: isLoaded ? 'block' : 'none' }}
            onLoad={handleLoad}
            className={cn('rounded-inherit size-full', className)}
          />
        </>
      ) : (
        <StatusAlertIcon className="m-auto" size="2xsmall" />
      )}
    </div>
  );
};
